import { ChevronDown } from "lucide-react";

export const HeaderApprovedBuys = ({
    summaryIsOpened,
    setSummaryIsOpened,
    reviewQueueIsOpened,
    setReviewQueueIsOpened,
}) => {
    return (
        <div className="flex flex-col gap-3 border-b border-border pb-4 lg:flex-row lg:items-start lg:justify-between">
            <div>
                <div className="mb-2 flex items-center gap-2">
                    <span className="inline-flex items-center justify-center w-fit whitespace-nowrap shrink-0 [&>svg]:size-3 gap-1 [&>svg]:pointer-events-none focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px] aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive transition-[color,box-shadow] overflow-hidden [a&]:hover:bg-primary/90 rounded-md border border-border bg-background px-2 py-1 text-[11px] font-medium text-primary shadow-none">
                        Approved Buys
                    </span>
                </div>
                <h2 className="text-xl font-semibold tracking-[-0.02em] text-primary">
                    Approved buy review queue
                </h2>
                <p className="mt-1 max-w-3xl text-sm text-gray-600">
                    Approved BUY rows are separated from Open To Buy so planners can review grouped draft purchase-order candidates and approval history without pushing the workbook table down.
                </p>
            </div>
            <div className="flex flex-wrap items-center gap-2">
                <button
                    onClick={() => {
                        setSummaryIsOpened(!summaryIsOpened);
                    }}
                    className="inline-flex items-center justify-center gap-2 whitespace-nowrap text-sm font-medium transition-all disabled:pointer-events-none disabled:opacity-50 [&_svg]:pointer-events-none [&_svg:not([class*='size-'])]:size-4 shrink-0 [&_svg]:shrink-0 outline-none focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px] aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive border shadow-xs hover:bg-gray-50 dark:bg-transparent dark:border-input dark:hover:bg-input/50 h-9 px-4 py-2 has-[>svg]:px-3 rounded-md bg-white"
                >
                    <ChevronDown className={`h-4 w-4 transition-transform ${summaryIsOpened ? "rotate-180" : ""}`}/>
                    <span>{summaryIsOpened ? "Hide" : "Show"} Summary</span>
                </button>
                <button
                    onClick={() => {
                        setReviewQueueIsOpened(!reviewQueueIsOpened);
                    }}
                    className="inline-flex items-center justify-center gap-2 whitespace-nowrap text-sm font-medium transition-all disabled:pointer-events-none disabled:opacity-50 [&_svg]:pointer-events-none [&_svg:not([class*='size-'])]:size-4 shrink-0 [&_svg]:shrink-0 outline-none focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px] aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive border shadow-xs hover:bg-gray-50 dark:bg-transparent dark:border-input dark:hover:bg-input/50 h-9 px-4 py-2 has-[>svg]:px-3 rounded-md bg-white"
                >
                    <ChevronDown className={`h-4 w-4 transition-transform ${reviewQueueIsOpened ? "rotate-180" : ""}`}/>
                    <span>{reviewQueueIsOpened ? "Hide" : "Show"} Review Queue</span>
                </button>
            </div>
        </div>
    )
};